import { inject, Injectable, signal } from '@angular/core';
import { Bestyrelsesmedlem } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelsesmedlem.model';
import { BestyrelseDatasource } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelse.datasource';

@Injectable({
  providedIn: 'root'
})
export class BestyrelseService  {
  datasource = inject(BestyrelseDatasource);
  selectedBestyrelsesmedlem = signal<Bestyrelsesmedlem | undefined>(undefined);
  activeTab = signal('list');
  mode = signal('update');
  searchText = signal('');
  medtagSlettede = signal(false);

  selectBestyrelsesmedlem(bestyrelsesmedlem: Bestyrelsesmedlem) {
    this.mode.set('update');
    this.selectedBestyrelsesmedlem.set(bestyrelsesmedlem);

    if (bestyrelsesmedlem) {
      this.activeTab.set('detail');
    }
  }

  opretBestyrelsesmedlem() {
    this.mode.set('create');
    this.selectedBestyrelsesmedlem.set(undefined);
    this.activeTab.set('detail');
  }

  onSearch() {
    this.datasource.searchParams.set({
      text: this.searchText(),
      medtagSlettede: this.medtagSlettede()
    });
  }
}
